export enum LIT_NETWORK {
	DatilDev = "datil-dev",
	DatilTest = "datil-test",
	Datil = "datil",
}

export const SERVICE_URL_BY_NETWORKTYPE = {
	TestNetworks: "https://test.wrapped.litprotocol.com/encrypted",
	Production: "https://wrapped.litprotocol.com/encrypted",
};

export const WRAPPED_KEY_SERVICE_URL_BY_LIT_NETWORK = {
	[LIT_NETWORK.DatilDev]: SERVICE_URL_BY_NETWORKTYPE.TestNetworks,
	[LIT_NETWORK.DatilTest]: SERVICE_URL_BY_NETWORKTYPE.TestNetworks,
	[LIT_NETWORK.Datil]: SERVICE_URL_BY_NETWORKTYPE.Production,
};

export const LIT_SESSIONSIG_AUTHORIZATION_SCHEMA_PREFIX = "LitSessionSig:";

export const supportedNetworks = [
	LIT_NETWORK.DatilDev,
	LIT_NETWORK.DatilTest,
	LIT_NETWORK.Datil,
];
